export const RATE_MODE = {
  NONE: "NONE",

  INVALID_MANUAL_CURRENCY: "INVALID_MANUAL_CURRENCY",

  MANUAL_MNT_TO_MNT: "MANUAL_MNT_TO_MNT",
  MANUAL_SAME_FOREIGN: "MANUAL_SAME_FOREIGN",

  TRANSFER_MNT_TO_MNT: "TRANSFER_MNT_TO_MNT",
  TRANSFER_SAME_FOREIGN: "TRANSFER_SAME_FOREIGN",
  TRANSFER_MNT_TO_FOREIGN: "TRANSFER_MNT_TO_FOREIGN",
  TRANSFER_FOREIGN_TO_MNT: "TRANSFER_FOREIGN_TO_MNT",
  TRANSFER_FOREIGN_TO_FOREIGN: "TRANSFER_FOREIGN_TO_FOREIGN",
};

function createRateMode({
  key,
  senderFixed = false,
  receiverFixed = false,
  senderDefault = undefined,
  receiverDefault = undefined,
  sharedInput = false,
  requireSenderRate = false,
  requireReceiverRate = false,
  requireSharedRate = false,
}) {
  return {
    key,
    senderFixed,
    receiverFixed,
    senderDefault,
    receiverDefault,
    sharedInput,
    requireSenderRate,
    requireReceiverRate,
    requireSharedRate,
  };
}

export function getRateMode({ isManual, senderCurrency, receiverCurrency }) {
  if (!senderCurrency || !receiverCurrency) {
    return createRateMode({
      key: RATE_MODE.NONE,
    });
  }

  const senderIsMnt = senderCurrency === "MNT";
  const receiverIsMnt = receiverCurrency === "MNT";
  const sameCurrency = senderCurrency === receiverCurrency;

  if (isManual) {
    if (!sameCurrency) {
      return createRateMode({
        key: RATE_MODE.INVALID_MANUAL_CURRENCY,
      });
    }

    if (senderIsMnt && receiverIsMnt) {
      return createRateMode({
        key: RATE_MODE.MANUAL_MNT_TO_MNT,
        senderFixed: true,
        receiverFixed: true,
        senderDefault: 1,
        receiverDefault: 1,
      });
    }

    return createRateMode({
      key: RATE_MODE.MANUAL_SAME_FOREIGN,
      sharedInput: true,
      requireSharedRate: true,
    });
  }

  if (sameCurrency && senderIsMnt && receiverIsMnt) {
    return createRateMode({
      key: RATE_MODE.TRANSFER_MNT_TO_MNT,
      senderFixed: true,
      receiverFixed: true,
      senderDefault: 1,
      receiverDefault: 1,
    });
  }

  if (sameCurrency && !senderIsMnt && !receiverIsMnt) {
    return createRateMode({
      key: RATE_MODE.TRANSFER_SAME_FOREIGN,
      sharedInput: true,
      requireSharedRate: true,
    });
  }

  if (senderIsMnt && !receiverIsMnt) {
    return createRateMode({
      key: RATE_MODE.TRANSFER_MNT_TO_FOREIGN,
      senderFixed: true,
      senderDefault: 1,
      requireReceiverRate: true,
    });
  }

  if (!senderIsMnt && receiverIsMnt) {
    return createRateMode({
      key: RATE_MODE.TRANSFER_FOREIGN_TO_MNT,
      receiverFixed: true,
      receiverDefault: 1,
      requireSenderRate: true,
    });
  }

  return createRateMode({
    key: RATE_MODE.TRANSFER_FOREIGN_TO_FOREIGN,
    requireSenderRate: true,
    requireReceiverRate: true,
  });
}

export function applyRateModeToValues(rateMode, currentValues = {}) {
  const next = { ...currentValues };

  switch (rateMode.key) {
    case RATE_MODE.MANUAL_MNT_TO_MNT:
    case RATE_MODE.TRANSFER_MNT_TO_MNT:
      next.sharedRate = undefined;
      next.senderRate = 1;
      next.receiverRate = 1;
      return next;

    case RATE_MODE.MANUAL_SAME_FOREIGN:
    case RATE_MODE.TRANSFER_SAME_FOREIGN: {
      const shared =
        currentValues.sharedRate ??
        currentValues.senderRate ??
        currentValues.receiverRate;

      next.sharedRate = shared;
      next.senderRate = shared;
      next.receiverRate = shared;
      return next;
    }

    case RATE_MODE.TRANSFER_MNT_TO_FOREIGN:
      next.sharedRate = undefined;
      next.senderRate = 1;
      next.receiverRate = currentValues.receiverRate;
      return next;

    case RATE_MODE.TRANSFER_FOREIGN_TO_MNT:
      next.sharedRate = undefined;
      next.senderRate = currentValues.senderRate;
      next.receiverRate = 1;
      return next;

    case RATE_MODE.TRANSFER_FOREIGN_TO_FOREIGN:
      next.sharedRate = undefined;
      next.senderRate = currentValues.senderRate;
      next.receiverRate = currentValues.receiverRate;
      return next;

    case RATE_MODE.INVALID_MANUAL_CURRENCY:
    case RATE_MODE.NONE:
    default:
      return next;
  }
}